<!--Reportable Incident-->
<template>
    <div v-if="dataNotNull" key="1" style="width: 100%; height: 100%;">
        <div class="title_con_incident">Daily Reportable Incident <br/>(By Project)
        </div>
        <dv-scroll-board :config="config" style="margin-top: 30px;margin-left:30px;width:400px;height:140px"/>
    </div>

    <div v-else key="2" style="width: 100%; height: 100%;">
        <div class="title_tbm">Daily Reportable Incident <br/>(By Project)</div>
        <div class="zero_tbm">No Data !</div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "incident",

        data() {
            return {
                incidents: [],
                color: this.$store.state.color.chart_color,
                name: "incident",
                dataNotNull: false,
                config: {
                    data: [],
                    oddRowBGC: 'transparent',
                    evenRowBGC: 'transparent',
                    align: ['left', 'center']
                },
            }
        },
        methods: {
            init() {
                // this.$root.charts.push(this.myChart)
                window.addEventListener("resize", function () {
                    this.myChart.resize()
                }.bind(this))
            },
        },
        mounted() {
            let postData = {
                cms_conid: window.localStorage.getItem('cons_id'),
                type: true,
                user: window.localStorage.getItem("token_key"),
                token: window.localStorage.getItem('token')
            }
            axios.post(this.$store.getters.getCmsServer + "DBConIncident", postData).then(resp => {
                var errNo = resp.data.errno
                var errStr = resp.data.errstr_cn
                if (errNo == "0") {
                    this.dataNotNull = true
                    var result = resp.data.result
                    for (let i in result) {
                        let res = []
                        res.push(result[i].pro_name)
                        res.push(result[i].count.toString())
                        this.sum += result[i].count
                        this.config.data.push(res)
                    }
                } else {
                    this.dataNotNull = false
                }
            }).catch(error => {
                alert("DBConIncident.error:" + error)
                this.dataNotNull = false
            })
        }
    }
</script>

<style lang="stylus" scoped>
    .title_con_incident
        width 100%
        height 10%
        text-align left
        font-weight bold
        font-size 16px
        color #FFF
        padding-top 17px
        padding-left 25px

    .zero_con_incident
        width 100%
        height 100%
        text-align center
        padding-top 15%
        font-size 28px
        color #6CF

    ul {
        width 100%
        height 70%
        margin 0 auto
        list-style-type none
        padding-left 0
        padding-top 25px
    }

    li {
        font-size 20px
        text-align left
        margin-left 0
        height: 20%
    }

    .content_name {
        width 65%
        float left
        font-size 12px
        color white
        padding-left 30px
        padding-right 20px
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
        -moz-text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content_count {
        width 15%
        float left
        color white
        font-weight bold
        font-size 12px
        text-align right
        padding-right 16px
    }
</style>



// WEBPACK FOOTER //
// src/components/constractor/incident.vue